import React, { useEffect, useState } from "react";
import { Grid, Typography } from "@mui/material";
import { ToggleButtonGroup } from "@mui/material";
import { injectIntl } from "react-intl";
import SvgIcon from "../../components/SvgIcon";
import {
  IconButtonGroup,
  IconButton,
  StyleToggleButton,
  StyleInputLabel,
  StyleTextField,
  StyleButtonLarge,
  StyleModal,
  StickyButton,
} from "../../assets/js/Theme";
import { Formik } from "formik";
import { getFeedbackOptions, postFeedback } from "../../crud/avm.crud";
const Feedback = (props) => {
  const { intl, metaData, pageType, position, feedbackActionComplete, show = false, onOpen} = props;
  const tempInitialValues = {
    faceId: "", // id
    reasons: [], // array string value
    comments: "", // string
    // applicationSource
    // userId
    // companyId
  };
  // const [initialValues, setInitialValues] = useState(tempInitialValues);
  const [showHappinessMeter, setShowHappinessMeter] = useState(true);
  const [selectedFeedback, setSelectedFeedback] = useState();
  const [feedbackOptions, setFeedbackOptions] = useState([]);
  // const [feedbackOptionsLoading, setFeedbackOptionsLoading] = useState(false);
  // const [feedbackLoading, setFeedbackLoading] = useState(false);
  const [showFeedback, setShowFeedback] = useState(show);
  const [formValues, setFormValues] = useState(tempInitialValues);

  useEffect(() => {
    setShowFeedback(show)
  }, [show])
  const _getFeedbackOptions = async () => {
    try {
      // setFeedbackOptionsLoading(true);
      const result = await getFeedbackOptions();
      // setFeedbackOptionsLoading(false);
      const { status, data } = result.data;
      if (status === 1) {
        setFeedbackOptions(data);
      } else {
        console.log("data are not populated");
      }
    } catch (e) {
      // setFeedbackOptionsLoading(false);
      console.log(e);
    }
  };

  const _handleFeedback = async () => {
    try {
      if (formValues.faceId) {
        // setFeedbackLoading(true);
        const postParams = {
          faceId: formValues.faceId,
          reasons: formValues.reasons.join(","),
          comments: formValues.comments,
          applicationSource: "consumer-avm",
          userId: metaData?.userId || "",
          companyId: metaData?.companyId || "",
          // reportId: metaData?.reportId || "",
          reportHash: metaData?.reportHash || "",
          sessionId: metaData?.currentSession || "",
          context: metaData?.context || "",
        };
        const result = await postFeedback(postParams);
        // setFeedbackLoading(false);
        const { status } = result.data;
        if (status === 1) {
          setFormValues(tempInitialValues)
          feedbackActionComplete && feedbackActionComplete('done')
        } else {
          console.log("data are not populated");
        }
      } else {
        feedbackActionComplete && feedbackActionComplete('close') //close widget action
      }
      setShowHappinessMeter(true);
    } catch (e) {
      // setFeedbackLoading(false);
      console.log(e);
    }
  };

  useEffect(() => {
    _getFeedbackOptions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {pageType === "modal" && (
        <StickyButton
          variant="contained"
          color="secondary"
          onClick={() => {
            onOpen('feedback', 'widgetClick')
          }}
          className={`${"feedback--btn"} position--${position}`}
        >
          {intl.formatMessage({ id: "FEEDBACK.HEADING_TITLE" })}
        </StickyButton>
      )}
      <StyleModal
        open={pageType === "modal" ? showFeedback : true}
        onClose={() => {
          _handleFeedback();
        }}
        className={
          pageType === "modal" ? "modal--wrapper" : "single--page--wrapper"
        }
      >
        <div className={pageType === "modal" ? "modal--block" : "page--block"}>
          <Grid container alignItems="center" className="modal--header">
            <Grid item xs={pageType === "modal" ? 10 : 12}>
              <Typography color="primary" variant="h4">
                {intl.formatMessage({ id: "FEEDBACK.HEADING_TITLE" })}
              </Typography>
            </Grid>
            <Grid item xs={pageType === "modal" ? 2 : "auto"} align="right">
              <StyleButtonLarge
                onClick={() => {
                  _handleFeedback();
                }}
              >
                <SvgIcon name="cross" />
              </StyleButtonLarge>
            </Grid>
          </Grid>
          <div className="modal--content--wrapper feedback-modal">
            <Formik
              enableReinitialize={true}
              initialValues={formValues}
              onSubmit={_handleFeedback}
            >
              {({ values, handleSubmit, setFieldValue, resetForm }) => (
                <form
                  noValidate={true}
                  autoComplete="off"
                  className="kt-form"
                  onSubmit={handleSubmit}
                >
                  <Grid
                    container
                    spacing={3}
                    alignItems="center"
                    justifyContent="center"
                    className="feedback--wrapper"
                  >
                    {showHappinessMeter ? (
                      <>
                        <Grid item xs={12} align="center">
                          <Typography color="primary" variant="h4">
                            {intl.formatMessage({
                              id: "FEEDBACK.LABEL.HOW_WAS_YOUR_EXPERIENCE",
                            })}
                          </Typography>
                        </Grid>
                        <Grid item xs={12} align="center">
                          <IconButtonGroup
                            exclusive
                            className="icon--wrapper"
                            value={values.faceId}
                            onChange={(event, value) => {
                              if (value !== null) {
                                const tempFormValues = { ...formValues };
                                tempFormValues.faceId = value.id;
                                setFormValues(tempFormValues);
                                setSelectedFeedback(value);
                                setFieldValue("faceId", value.id);
                                setShowHappinessMeter(false);
                              }
                            }}
                          >
                            {feedbackOptions.map((value, index) => (
                              <IconButton
                                color="secondary"
                                key={index}
                                value={value}
                                className="feedback-icon-button"
                              >
                                <SvgIcon name={value.icon} />
                              </IconButton>
                            ))}
                          </IconButtonGroup>
                        </Grid>
                      </>
                    ) : (
                      <>
                        <Grid item xs={12} className="reason--wrapper">
                          <Grid container>
                            <Grid item xs={12}>
                              <Grid
                                container
                                spacing={2}
                                align="left"
                                alignItems="center"
                              >
                                <Grid item xs={"auto"}>
                                  <SvgIcon name={selectedFeedback.icon} />
                                </Grid>
                                <Grid item xs={"auto"}>
                                  <Typography color="primary" variant="h5">
                                    {selectedFeedback.description}
                                  </Typography>
                                </Grid>
                              </Grid>
                            </Grid>
                            <Grid item xs={12}>
                              <Grid container spacing={3}>
                                <Grid item xs={12}>
                                  <ToggleButtonGroup
                                    value={values.reasons}
                                    className="flex-wrap"
                                    onChange={(event, value) => {
                                      setFieldValue("reasons", value);
                                      const tempFormValues = { ...formValues };
                                      tempFormValues.reasons = value;
                                      setFormValues(tempFormValues);
                                    }}
                                  >
                                    {selectedFeedback.reasons.map(
                                      (reason, index) => (
                                        <StyleToggleButton
                                          color="secondary"
                                          key={index}
                                          value={reason.id}
                                        className="margin-top-10"
                                        >
                                          <Typography
                                            component="span"
                                            className="icon--wrapper"
                                          >
                                            {reason.name}
                                          </Typography>
                                        </StyleToggleButton>
                                      )
                                    )}
                                  </ToggleButtonGroup>
                                </Grid>
                                <Grid item xs={12} className="form-group">
                                  <StyleInputLabel
                                    htmlFor="bootstrap-input"
                                    color="primary"
                                  >
                                    {intl.formatMessage({
                                      id: "GENERAL.COMMENTS",
                                    })}
                                  </StyleInputLabel>
                                  <StyleTextField
                                    minRows={4}
                                    multiline
                                    fullWidth
                                    id="comments"
                                    name="comments"
                                    variant="outlined"
                                    value={values.comments}
                                    onChange={(event) => {
                                      setFieldValue(
                                        "comments",
                                        event.target.value
                                      );
                                      const tempFormValues = { ...formValues };
                                      tempFormValues.comments =
                                        event.target.value;
                                      setFormValues(tempFormValues);
                                    }}
                                  />
                                </Grid>
                              </Grid>
                            </Grid>
                            <Grid item xs={12}>
                              <Grid
                                container
                                spacing={3}
                                className="button--wrapper"
                                justifyContent="space-between"
                              >
                                <Grid item xs={12} md={2}>
                                  <StyleButtonLarge
                                    variant="outlined"
                                    fullWidth
                                    color="primary"
                                    size="large"
                                    className="btn--wrapper"
                                    onClick={() => {
                                      resetForm();
                                      setFormValues(tempInitialValues);
                                      setShowHappinessMeter(true);
                                    }}
                                  >
                                    {intl.formatMessage({
                                      id: "GENERAL.BACK",
                                    })}
                                  </StyleButtonLarge>
                                </Grid>
                                <Grid item xs={12} md={2}>
                                  <StyleButtonLarge
                                    type="submit"
                                    variant="contained"
                                    fullWidth
                                    color="secondary"
                                    size="large"
                                    className="btn--wrapper"
                                  >
                                    {intl.formatMessage({
                                      id: "GENERAL.SUBMIT",
                                    })}
                                  </StyleButtonLarge>
                                </Grid>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                      </>
                    )}
                  </Grid>
                </form>
              )}
            </Formik>
          </div>
        </div>
      </StyleModal>
    </>
  );
};

export default injectIntl(Feedback);
